export default {
    setEstimatedMortgage({ commit }, payload) {
        commit('setEstimatedMortgage', payload);
    }
};
